import { buildImgSrc } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import NextHead from 'next/head'
import * as React from 'react'

interface OpenGraphProps {
  title: string
  description: string
  image: {
    url: string
    width?: number
    height?: number
  }
  url: string
}

export function OpenGraphTags({ title, description, image, url }: OpenGraphProps) {
  const intl = useIntl()

  const imageWidth = image.width || 1200
  const imageHeight = image.height || 630

  return (
    <NextHead>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={buildImgSrc(image.url, imageWidth, imageHeight)} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={intl.locale.replace(/_/g, '-')} />
      <meta property="og:image:width" content={imageWidth.toString()} />
      <meta property="og:image:height" content={imageHeight.toString()} />
    </NextHead>
  )
}
